import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
@Injectable({
  providedIn: "root",
})
export class TranslateService {
  selectedLang: string = "English";
  selectedLangCode: string = "en";
  data: any = {};
  languageList:any=[];
  constructor(private http: HttpClient, private titleService: Title) {}
  setLanguage(lang: any) {
    this.selectedLang = lang.label;
    this.selectedLangCode=lang.value;
    this.use(lang.value).then(() => { });
  }
  use(lang: string): Promise<{}> {
    return new Promise<{}>((resolve, reject) => {
      const langPath = `assets/i18n/${lang || "en"}.json`;
      this.http.get<{}>(langPath).subscribe(
        (translation) => {
          this.data = Object.assign({}, translation || {});
          this.titleService.setTitle(this.data.TITLE);
          resolve(this.data);
        },
        (error) => {
          this.data = {};
          resolve(this.data);
        }
      );
    });
  }
  getLangList() {
    return this.http.get("assets/i18n/langlist.json");
  }
  tCountryNCurrencyList(data,type) {
    return data.filter((c) => {
      if (this.data[type].hasOwnProperty(c.code)) {
        c.label = this.data[type][c.code];
        c.value = this.data[type][c.code];
        return c;
      }
    });
  }
}
